const columnDetail = () => {
    const toc = document.querySelector(".js-column-toc");
    if (!toc) return;

    const more = toc.querySelector(".js-column-toc-more");
    const close = toc.querySelector(".js-column-toc-close");
    const list = toc.querySelector(".js-column-toc-list");

    const buildTocFromHeadings = () => {
        if (!list || list.children.length > 0) return;

        const cms = document.querySelector(".p-column-detail__cms");
        if (!cms) return;

        const headings = [...cms.querySelectorAll("h2, h3")].filter((heading) => heading.textContent.trim());
        if (!headings.length) return;

        let h2Index = 0;
        let h3Index = 0;
        let currentSub = null;

        headings.forEach((heading, index) => {
            const id = heading.id || `column-sec-${index + 1}`;
            heading.id = id;
            const text = heading.textContent.trim();
            const isH2 = heading.tagName === "H2";

            if (isH2) {
                h2Index += 1;
                h3Index = 0;
                const li = document.createElement("li");
                const link = document.createElement("a");
                link.href = `#${id}`;
                link.innerHTML = `<span class="p-column-detail__toc-num">${h2Index}.</span><span class="p-column-detail__toc-label"></span>`;
                link.querySelector(".p-column-detail__toc-label").textContent = text;
                li.appendChild(link);
                list.appendChild(li);
                currentSub = null;
                return;
            }

            if (!currentSub) {
                const lastLi = list.lastElementChild;
                if (lastLi) {
                    currentSub = document.createElement("ol");
                    lastLi.appendChild(currentSub);
                }
            }

            if (!currentSub) {
                h2Index += 1;
                const li = document.createElement("li");
                const link = document.createElement("a");
                link.href = `#${id}`;
                link.innerHTML = `<span class="p-column-detail__toc-num">${h2Index}.</span><span class="p-column-detail__toc-label"></span>`;
                link.querySelector(".p-column-detail__toc-label").textContent = text;
                li.appendChild(link);
                list.appendChild(li);
                return;
            }

            h3Index += 1;
            const li = document.createElement("li");
            const link = document.createElement("a");
            link.href = `#${id}`;
            link.innerHTML = `<span class="p-column-detail__toc-num">${h2Index}-${h3Index}.</span><span class="p-column-detail__toc-label"></span>`;
            link.querySelector(".p-column-detail__toc-label").textContent = text;
            li.appendChild(link);
            currentSub.appendChild(li);
        });
    };

    const syncOverflow = () => {
        const body = toc.querySelector(".p-column-detail__toc-body");
        if (!body || toc.classList.contains("is-open")) return;
        toc.classList.toggle("is-short", body.scrollHeight <= body.clientHeight + 4);
    };

    buildTocFromHeadings();

    if (list && list.children.length > 0) {
        toc.hidden = false;
        syncOverflow();
    }

    more?.addEventListener("click", () => {
        toc.classList.add("is-open");
        toc.classList.remove("is-short");
    });

    close?.addEventListener("click", () => {
        toc.classList.remove("is-open");
        syncOverflow();
    });
};

export default columnDetail;
